import { AppState } from 'react-native';

import staticConfig from 'config/static-config.json';

import { RequestStatus } from '../utils';
import {
    getLanguagesFailure,
    setAppState,
    setConsentOrdering,
    setDidomiUserStatus,
    setInitialWebPathName,
    setReduceMotionEnabled,
    setScreenReaderEnabled,
    setSplashScreenState,
} from './actions';
import {
    GET_LANGUAGES_FAILURE,
    GET_LANGUAGES_SUCCESS,
    SET_APP_STATE,
    SET_CONSENT_ORDERING,
    SET_DIDOMI_USER_STATUS,
    SET_INITIAL_WEB_PATHNAME,
    SET_REDUCE_MOTION_ENABLED,
    SET_SCREEN_READER_ENABLED,
    SET_SPLASH_SCREEN_STATE,
} from './constants';
import { ConfigState } from './reducer.types';

const { api_config, app_config, layout_config } = staticConfig;

const initialState: ConfigState = {
    api: api_config,
    app: app_config,
    layout: layout_config,
    getLanguagesRequest: {
        status: RequestStatus.IDLE,
        error: null,
    },
    appState: AppState.currentState,
    initialWebPathParams: {
        pathName: '',
    },
    reduceMotionEnabled: false,
    screenReaderEnabled: false,
    consentOrdering: undefined,
    didomiUserStatus: undefined,
    splashScreen: {
        visible: true,
    },
};

const handlers = {
    [GET_LANGUAGES_SUCCESS](state: ConfigState): ConfigState {
        return {
            ...state,
            getLanguagesRequest: {
                ...state.getLanguagesRequest,
                status: RequestStatus.SUCCESS,
            },
        };
    },
    [GET_LANGUAGES_FAILURE](
        state: ConfigState,
        { payload: { error } }: ReturnType<typeof getLanguagesFailure>,
    ): ConfigState {
        return {
            ...state,
            getLanguagesRequest: {
                ...state.getLanguagesRequest,
                status: RequestStatus.FAILURE,
                error,
            },
        };
    },

    [SET_APP_STATE](
        state: ConfigState,
        { payload: { appState } }: ReturnType<typeof setAppState>,
    ): ConfigState {
        return {
            ...state,
            appState,
        };
    },

    [SET_INITIAL_WEB_PATHNAME](
        state: ConfigState,
        {
            payload: { initialWebPathParams },
        }: ReturnType<typeof setInitialWebPathName>,
    ): ConfigState {
        return {
            ...state,
            initialWebPathParams,
        };
    },

    [SET_REDUCE_MOTION_ENABLED](
        state: ConfigState,
        {
            payload: { reduceMotionEnabled },
        }: ReturnType<typeof setReduceMotionEnabled>,
    ): ConfigState {
        return {
            ...state,
            reduceMotionEnabled,
        };
    },
    [SET_SCREEN_READER_ENABLED](
        state: ConfigState,
        {
            payload: { screenReaderEnabled },
        }: ReturnType<typeof setScreenReaderEnabled>,
    ): ConfigState {
        return {
            ...state,
            screenReaderEnabled,
        };
    },
    [SET_CONSENT_ORDERING](
        state: ConfigState,
        { payload: { consentOrdering } }: ReturnType<typeof setConsentOrdering>,
    ): ConfigState {
        return {
            ...state,
            consentOrdering,
        };
    },
    [SET_DIDOMI_USER_STATUS](
        state: ConfigState,
        {
            payload: { didomiUserStatus },
        }: ReturnType<typeof setDidomiUserStatus>,
    ): ConfigState {
        return {
            ...state,
            didomiUserStatus,
        };
    },

    [SET_SPLASH_SCREEN_STATE](
        state: ConfigState,
        { payload }: ReturnType<typeof setSplashScreenState>,
    ): ConfigState {
        return {
            ...state,
            splashScreen: {
                ...state.splashScreen,
                ...payload,
            },
        };
    },
};

export default { initialState, handlers };
